import { render, staticRenderFns } from "./DevCards.vue?vue&type=template&id=1b856249"
import script from "./DevCards.vue?vue&type=script&lang=js"
export * from "./DevCards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports